export default "__VITE_ASSET__D5EB_jMr__"